module.exports = __webpack_public_path__ + "img/bg_avatar_male_61.72a47ddf.png";